<template>
  <div class="room-detail container">
    <div class="room-img">
      <div class="img-left" v-if="detailInfo.imgList">
        <el-image class="img" fit="cover" :src="detailInfo.imgList[0]"
                  :preview-src-list="detailInfo.imgList"></el-image>
      </div>
      <div class="img-right">
        <template v-for="(item, index) in detailInfo.imgList">
          <el-image class="img" fit="cover" :src="item" :key="index" v-if="index != 0"
                    :preview-src-list="detailInfo.imgList"></el-image>
        </template>
      </div>
    </div>
    <div class="coupons-area-box" v-if="detailInfo.roomTypeRes && detailInfo.roomSpecRes">
      <p class="main_info">{{ detailInfo.roomTypeRes.name }}-{{ detailInfo.roomSpecRes.name }}</p>
      <p class="main_info">{{ detailInfo.roomTypeRes.nameEn }}-{{ detailInfo.roomSpecRes.nameEn }}</p>
      <div class="coupons-area" v-if="allCouponList.length">
        <div class="coupon-item" v-for="item in couponList" :key="item.id" v-if="item.formatName">
          <span>{{ item.formatName }}</span>
          <span>{{ item.formatNameEn }}</span>
        </div>
        <el-button class="get-coupon fl-center" @click="getCoupon">领券 Coupon collection</el-button>
      </div>
    </div>

    <div v-if="detailInfo.roomTypeRes && detailInfo.roomTypeRes.posterDistributeSwitch == 1 && shareImg"
         class="distribution-shared container">
      <p style="margin-right:20px">分销可得佣金，需在小程序端分享 Distribution Commission, to be shared on the applet side</p>
      <el-popover title="" width="300" trigger="hover">
        <el-image :src="shareImg"></el-image>
        <div class="qrcode" slot="reference">
          <el-image class="shareImg" :src="shareImg"/>
        </div>
      </el-popover>
    </div>

    <!-- <div class="distribution-shared" v-if="detailInfo.roomTypeRes && detailInfo.roomTypeRes.posterDistributeSwitch == 1">
      <p>分销可得佣金，需在小程序端分享 Distribution Commission, to be shared on the applet side</p>
      <img class="shareImg" :src="shareImg" />
    </div> -->
    <div class="hotel_service_con" v-if="detailInfo.hotelRoomService">
      <template v-for="item in detailInfo.hotelRoomService">
        <div class="service_item" :key="item.id" v-if="item.value == 1">
          <div class="service_item_text">
            <span>{{ item.chName }}</span>
            <span>{{ item.enName }}</span>
          </div>
          <img class="image" :src="item.icon"/>
        </div>
      </template>
    </div>
    <div class="good_detail">
      <template v-for="item in detailInfo.policyList">
        <div class="hotel_policy" v-if="item.effectiveLength > 0" :key="item.id">
          <div class="title_n">
            <span>{{ item.title }}</span>
          </div>
          <template v-if="item.type == 'fees'">
            <div class="policy_item">
              <template v-for="it in item.list">
                <div class="policy_item_content" :key="it.id" v-if="it.value == 1">
                  <span>{{ it.name }}</span>
                  <span>{{ it.nameEn }}</span>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="policy_item">
              <template v-for="it in item.list"
              ><span v-if="it.value == 1" :key="it.id">{{ it.name }} {{it.nameEn}}</span></template
              >
            </div>
          </template>
        </div>
      </template>
      <div class="hotel_policy" v-if="detailInfo.roomTypeRes && detailInfo.roomTypeRes.remark">
        <div class="title_n">
          <span>其他 In the news</span>
        </div>
        <div class="policy_item">
          <span>{{ detailInfo.roomTypeRes.remark }}</span>
        </div>
      </div>
    </div>
    <div class="book-btn" v-if="detailInfo.outOfStock !== 1">
      <div class="room-price-wrap">
        <div class="pricec">￥{{ detailInfo.price }}</div>
        <div v-if="detailInfo.marketPrice" class="del-discount"> ¥{{ detailInfo.marketPrice }}</div>
        <div v-if="detailInfo.discount" class="discount-wrap" @click="toShowDiscount">
          <div>优惠￥{{ detailInfo.discount }}</div>
          <div class="discount-mark-icon"/>
        </div>
      </div>
      <el-button type="primary" class="detail" @click="toOrderRoom">立即预订 Book in</el-button>
    </div>
    <GetCouponsDialog :visible.sync="visible" :couponList="allCouponList"/>
    <DiscountDialog :visible.sync="discountShow" :discountData="detailInfo" />
  </div>
</template>

<script>
import GetCouponsDialog from "@/components/base/GetCouponsDialog.vue";
import DiscountDialog from "@/components/base/DiscountDialog.vue";

export default {
  name: "RoomDetail",
  components: {
    GetCouponsDialog,
    DiscountDialog
  },
  data() {
    return {
      detailInfo: {},
      couponList: [], //优惠券列表
      allCouponList: [], //全量优惠券列表
      visible: false, //是否显示优惠券弹窗
      discountShow: false,
      shareImg: "",
      detail: {},
      hotelRoomService: [
        {
          chName: "200²",
          enName: "Size",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/pf.png",
          value: 1,
        },
        {
          chName: "2人",
          enName: "Capacity",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/rs.png",
          value: 1,
        },
        {
          chName: "有窗",
          enName: "Windows",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/c.png",
          value: 0,
        },
        {
          chName: "无窗",
          enName: "Without windows",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/n_c.png",
          value: 0,
        },
        {
          chName: "部分有窗",
          enName: "Partial with windows",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/c.png",
          value: 0,
        },
        {
          chName: "1层",
          enName: "Floor",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/lc.png",
          value: 1,
        },
        {
          chName: "WIFI免费",
          enName: "Free wifi",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/wifi.png",
          value: 0,
        },
        {
          chName: "禁烟",
          enName: "No smoking",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/jy.png",
          value: 0,
        },
        {
          chName: "部分禁烟",
          enName: "Partial smoking",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/jy.png",
          value: 0,
        },
        {
          chName: "不禁烟",
          enName: "Smoking allowed",
          icon: "https://s3.cn-north-1.jdcloud-oss.com/noggin/slds-file/mp/hotelService/jy1.png",
          value: 0,
        },
      ],
      policyList: [
        {
          title: "便利设施 Conveniences",
          type: "amenities",
          list: [
            {name: "空调",nameEn:'Air conditioner', value: 0},
            {name: "书桌",nameEn:"Desk", value: 0},
            {name: "台灯", nameEn:"Lamp",value: 0},
            {name: "遮光窗帘",nameEn:"Curtain", value: 0},
            {name: "多规格插座", nameEn:"Multi-gauge socket",value: 0},
            {name: "针线包", nameEn:"Needle bag",value: 0},
            {name: "衣柜",nameEn:"Closet", value: 0},
            {name: "衣架", nameEn:"Clothes hangers",value: 0},
            {name: "鸭绒被", nameEn:"Duck down quilt",value: 0},
          ],
        },
        {
          title: "浴室 Bathroom",
          type: "bathroom",
          list: [
            {name: "独立淋浴间",nameEn:"Private shower room", value: 0},
            {name: "智能马桶",nameEn:"Smart toilet", value: 0},
            {name: "吹风机", nameEn:"Hair dryer",value: 0},
            {name: "洗浴用品", nameEn:"Toiletries",value: 0},
            {name: "毛巾", nameEn:"Towel",value: 0},
            {name: "浴缸",nameEn:"Bathtub", value: 0},
            {name: "24小时热水", nameEn:"24 hours hot water",value: 0},
            {name: "拖鞋", nameEn:"Slippers",value: 0},
          ],
        },
        {
          title: "食品饮品 Food and drink",
          type: "foodDrink",
          list: [
            {name: "茶包", nameEn:"Tea bag",value: 0},
            {name: "咖啡", nameEn:"Coffee",value: 0},
            {name: "瓶装水", nameEn:"Bottled water",value: 0},
            {name: "电热水壶", nameEn:"Kettle",value: 0},
          ],
        },
        {
          title: "媒体科技 Media Technology",
          type: "media",
          list: [
            {name: "电视机",nameEn:"Television", value: 0},
            {name: "投影仪",nameEn:"Projectors", value: 0},
            {name: "电话", nameEn:"Telephone",value: 0},
            {name: "智能门锁", nameEn:"Smart door lock",value: 0},
            {name: "智能音箱", nameEn:"Smart speaker",value: 0},
            {name: "LED屏", nameEn:"LED display",value: 0},
          ],
        },
        {
          title: "室外景观 Outdoor landscape",
          type: "outdoorLandscape",
          list: [
            {name: "城景", nameEn:"City view",value: 0},
            {name: "海景", nameEn:"Sea View",value: 0},
          ],
        },
      ],
      seatImage: require("@/assets/img/moren.png"),
    };
  },
  props: {},
  computed: {},
  async mounted() {
    let orderTime = this.$route.query;
    this.detail = orderTime;
    this.getRoomDetail(orderTime);
    this.getlistForRoom(orderTime.id);
  },
  methods: {
    async getRoomDetail(detail) {
      const params = {
        specTypeId: detail.id,
        saleDateStart: detail.startTime,
        saleDateEnd: detail.endTime,
        channelCode: detail.channelCode
      };
      let {data} = await this.$api.getRoomDetail(params);
      let detailInfo = data || {};
      detailInfo.imgList = detailInfo.roomTypeRes.images.split(",");
      detailInfo.imgList.length = 5;
      for (let i = 0; i < detailInfo.imgList.length; i++) {
        detailInfo.imgList[i] = detailInfo.imgList[i] || this.seatImage;
      }
      detailInfo.policyList = this.getPolicy(detailInfo);
      detailInfo.hotelRoomService = this.getService(detailInfo);
      this.detailInfo = detailInfo;
      if (detailInfo.outOfStock === 1) {
        this.$message.error('该房型已售罄');
        return;
      }
      if (detailInfo.roomTypeRes.posterDistributeSwitch == 1) {
        this.getQrCode(detail);
      }
      // console.log("detailInfo", detailInfo);
    },
    toShowDiscount (item) {
      this.discountShow = !this.discountShow;
    },
    getPolicy(detailInfo) {
      let policyList = this.policyList;
      let {amenities, bathroom, foodDrink, media, outdoorLandscape} = detailInfo.roomTypeRes;
      let policyMap = {
        amenities: amenities.split(""),
        bathroom: bathroom.split(""),
        foodDrink: foodDrink.split(""),
        media: media.split(""),
        outdoorLandscape: outdoorLandscape.split(""),
      };
      policyList.map((item) => {
        policyMap[item.type].length = item.list.length;
        let effectiveLength = 0;
        for (let i = 0; i < policyMap[item.type].length; i++) {
          item.list[i].value = policyMap[item.type][i];
          if (item.list[i].value == 1) {
            effectiveLength++;
          }
        }
        item.effectiveLength = effectiveLength;
        return item;
      });
      let fees = {
        title: "费用政策 Cost Policy",
        type: "fees",
        list: [
          {
            name: "该房型不可加床",
            nameEn: "Extra beds are not available for this type of room",
            value: 1,
          },
          {
            name: "加早",
            nameEn: "Adding breakfast for x yuan per person",
            value: 0,
          },
          {
            name: "免费停车",
            nameEn: "Free parking",
            value: 1,
          },
        ],
        effectiveLength: 10,
      };
      if (detailInfo.roomTypeRes.extraBadSwitch == 1) {
        fees.list[0].name = `加床：${detailInfo.roomTypeRes.extraBadPrice}元/床/间夜`;
        fees.list[0].nameEn = `Adding extra bed for x yuan per night：${detailInfo.roomTypeRes.extraBadPrice}RMB / Bed / Night`;
      }
      if (detailInfo.roomTypeRes.extraBreakfastPrice > 0) {
        fees.list[1].name = `加早：${detailInfo.roomTypeRes.extraBreakfastPrice}元/份`;
        fees.list[1].nameEn = `Adding breakfast for x yuan per person：${detailInfo.roomTypeRes.extraBreakfastPrice} RMB/Share`;
        fees.list[1].value = 1;
      }
      if (detailInfo.roomTypeRes.parkSwitch == 0) {
        fees.list[2].name = "停车场：免费停车";
        fees.list[2].nameEn = "Parking lot：Free parking";
      } else if (detailInfo.roomTypeRes.parkSwitch == 1) {
        fees.list[2].name = "停车场：部分停车";
        fees.list[2].nameEn = "Parking lot：Free parking with limits";
      } else {
        fees.list[2].name = "停车场：收费停车";
        fees.list[2].nameEn = "Parking lot：Parking with a fee";
      }
      return [fees].concat(policyList);
    },
    getService(detailInfo) {
      let hotelRoomService = this.hotelRoomService;
      hotelRoomService[0].chName = `${detailInfo.roomTypeRes.space} m²`;
      hotelRoomService[1].chName = `${detailInfo.roomTypeRes.personCount} 人间`;
      hotelRoomService[0].enName = `${detailInfo.roomTypeRes.space} ${hotelRoomService[0].enName}`;
      hotelRoomService[1].enName = `${detailInfo.roomTypeRes.personCount} ${hotelRoomService[1].enName}`;
      if (detailInfo.roomTypeRes.windowSwitch == 0) {
        //无窗
        hotelRoomService[2].value = 0;
        hotelRoomService[3].value = 1;
        hotelRoomService[4].value = 0;
      } else if (detailInfo.roomTypeRes.windowSwitch == 1) {
        hotelRoomService[2].value = 1;
        hotelRoomService[3].value = 0;
        hotelRoomService[4].value = 0;
      } else {
        hotelRoomService[2].value = 0;
        hotelRoomService[3].value = 0;
        hotelRoomService[4].value = 1;
      }
      hotelRoomService[5].chName = `${detailInfo.roomTypeRes.floor}层`;
      hotelRoomService[5].enName = `${detailInfo.roomTypeRes.floor}th floor`;
      if (detailInfo.roomTypeRes.wifiSwitch == 1) {
        hotelRoomService[6].value = 1;
      } else {
        hotelRoomService[6].value = 0;
      }
      if (detailInfo.roomTypeRes.smokingSwitch == 0) {
        hotelRoomService[9].value = 1;
        hotelRoomService[7].value = 0;
        hotelRoomService[8].value = 0;
      } else if (detailInfo.roomTypeRes.smokingSwitch == 1) {
        hotelRoomService[9].value = 0;
        hotelRoomService[7].value = 0;
        hotelRoomService[8].value = 1;
      } else if (detailInfo.roomTypeRes.smokingSwitch == 2) {
        hotelRoomService[9].value = 0;
        hotelRoomService[7].value = 1;
        hotelRoomService[8].value = 0;
      }
      return hotelRoomService;
    },
    //获取商品优惠券列表
    async getlistForRoom(id) {
      const params = {
        specTypeId: id,
        page: 1,
        pageSize: 100,
        channelCode: this.detail.channelCode,
      };
      try {
        let {data: {list},} = await this.$api.getlistForRoom(params);
        const couponList = list.slice(0, 2)
        this.couponList = couponList.map((currentValue) => {
          return this.fnFormatName(currentValue)
        })
        // console.log('this.couponList',this.couponList)
        this.allCouponList = list;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * 格式化优惠券名称
     * @param data
     */
    fnFormatName(data) {
      //couponType 券的类型 0-现金券、1-折扣券、2-礼品券、3-充值券
      //couponValue 折扣/券面值
      //writeOffConditionSwitch 门槛 ，1-有门槛、0-无门槛
      //writeOffConditionPrice 有门槛，满享
      //discountMaxAmount 最高抵扣
      const couponType = data.couponType
      let couponValue = data.couponValue
      const writeOffConditionSwitch = data.writeOffConditionSwitch
      const writeOffConditionPrice = data.writeOffConditionPrice
      const discountMaxAmount = data.discountMaxAmount
      let formatName = "";
      let formatNameEn = ""
      if (couponType == 0) {
        if (writeOffConditionSwitch == 0) {
          formatName = `¥${couponValue}`
          formatNameEn = `¥${couponValue}`
        } else {
          formatName = `￥${couponValue} (满 ￥${writeOffConditionPrice} 可用)`
          formatNameEn = `￥${couponValue} (payments over ￥${writeOffConditionPrice})`
        }
      } else if (couponType == 1) {
        if (typeof couponValue==="string")
          couponValue=+couponValue
        if (writeOffConditionSwitch == 0) {
          formatName = discountMaxAmount != null ? `${couponValue}折 ￥${discountMaxAmount}` : `${couponValue}折`
          formatNameEn = discountMaxAmount != null ? `${100-couponValue*10}% off ￥ ${discountMaxAmount} ` : `${100-couponValue*10}% off`

        } else {
          formatName = `${couponValue}折(满${writeOffConditionPrice}可用) `
          formatNameEn = ` ${100-couponValue*10}% off (payments over ¥${writeOffConditionPrice})`
        }
      }
      data.formatName = formatName
      data.formatNameEn = formatNameEn
      return data
    },
    getCoupon() {
      this.visible = true;
    },
    async getQrCode(detail) {
      const params = {
        endDate: detail.endTime,
        page: "implant/bookRoom/detail/index",
        shareKind: 1,
        shareType: 0,
        spuId: detail.id,
        startDate: detail.startTime,
      };
      try {
        let {data} = await this.$api.getBuildCode(params);
        this.shareImg = data ? data.codeUrl : "";
      } catch (error) {
        console.log(error);
      }
    },
    toOrderRoom() {
      this.$router.push({
        path: "/home/order-room",
        query: {
          startTime: this.detail.startTime,
          endTime: this.detail.endTime,
          id: this.detail.id,
          channelCode: this.detail.channelCode,
        },
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.room-detail {
  .room-img {
    margin-top: 60px;
    display: flex;

    .img-left {
      width: 589px;
      height: 590px;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .img-right {
      width: 590px;
      height: 590px;
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      overflow: hidden;

      .img {
        width: 285px;
        height: 285px;
      }
    }
  }

  .coupons-area-box {
    padding-bottom: 60px;
    border-bottom: 1px solid #f0f0f0;

    .main_info {
      margin: 0px;
      font-size: 20px;
      font-weight: bold;
      color: #333333;

      &:first-child {
        margin-top: 60px;
        margin-bottom: 10px;
      }
    }

    .coupons-area {
      width: 100%;
      display: flex;
      overflow: hidden;
      height: 40px;
      margin-top: 60px;

      .coupon-item {
        width: 170px;
        height: 40px;
        display: flex;
        margin-right: 20px;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        box-sizing: border-box;
        padding: 0 10px;
        background: url("~@/assets/img/coupon_bg.png") 0 0 /100% 100% no-repeat;
        span{
          font-size: 14px;
          width: 100%;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .get-coupon {
        width: 200px;
        height: 40px;
        background: #333333;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }

  .distribution-shared {
    margin-top: 58px;
    padding-bottom: 58px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;

    p {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }

    .shareImg /deep/ img {
      width: 100px;
      height: 100px;
    }
  }

  .hotel_service_con {
    margin-top: 65px;
    display: flex;
    padding-bottom: 63px;
    border-bottom: 1px solid #f0f0f0;

    .service_item {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 60px;

      .service_item_text {
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        box-sizing: border-box;

        span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
      }

      .image {
        width: 22px;
        height: auto;
        margin-left: 20px;
      }
    }
  }

  .good_detail {
    margin-top: 65px;
    border-bottom: 1px solid #f0f0f0;

    .hotel_policy {
      display: flex;

      .title_n {
        width: 206px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        text-align: left;
        flex: none;
      }

      .policy_item {
        margin-left: 100px;
        display: flex;
        flex-direction: column;
        line-height: 18px;

        .policy_item_content {
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          display: -webkit-flex;
          flex-direction: column;
          -webkit-flex-direction: column;
          -ms-flex-direction: column;

          span {
            margin-bottom: 28px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;

            &:first-child {
              margin-bottom: 5px;
            }
          }
        }

        span {
          margin-bottom: 28px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }

  .book-btn {
    margin: 51px 0;
    display: flex;
    align-items: center;

    .pricec {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    .detail {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      margin-left: 617px;
    }
    .room-price-wrap {
      display: flex;
      align-items: flex-end;
    }
    .del-discount {
      font-size: 12px;
      color: #A7A8AA;
      margin-left: 10px;
      line-height: 17px;
      text-decoration: line-through;
    }
    .discount-wrap {
      height: 17px;
      background: #E47C47;
      border-radius: 7px 7px 7px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #fff;
      padding: 0 5px;
      margin-left: 10px;
    }
    .discount-mark-icon {
      width: 11px;
      height: 11px;
      margin-left: 3px;
      background-size: 100% 100%;
      background-image: url('https://slhk-noggin.tos-cn-beijing.volces.com/slds-file/images/65a8a07e4089491abc690a3e9d724d6c.png');
    }
  }
}

/deep/ .coupon-list {
  .coupon-item {
    width: calc(50% - 15px) !important;
    position: relative;
    box-sizing: border-box;
  }
}
</style>
